import React from "react"
import { useTranslation } from "next-i18next"
import PropTypes from "prop-types"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import Style from "@/components/PartsViewer/v2/SelectedFileView/PrintShare/index.module.scss"

const PrintShare = props => {
  const { showShareModal = false, setShare, shareBtn, productId } = props
  const link = `${window.location.origin}/parts?number=${productId}`
  const { t } = useTranslation("common")
  const { mailBody, description, mailSubjectTextOne, mailSubjectTextTwo } =
    getTranslations(t)

  const emailSubjecttext = `${mailSubjectTextOne}-${mailSubjectTextTwo}-${productId}`

  return (
    <div className={Style.PrintShare}>
      <div className="share-widgets">
        <SocialShare
          asset={{
            url: link,
            description,
          }}
          id={`kf-my-product-tile-${productId}`}
          showModal={showShareModal}
          onClose={setShare}
          shareBtn={shareBtn}
          mailSubject={emailSubjecttext}
          mailBody={mailBody}
          url={link}
        />
      </div>
    </div>
  )
}

PrintShare.propTypes = {
  showShareModal: PropTypes.bool.isRequired,
  setShare: PropTypes.func.isRequired,
  shareBtn: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
}

export default PrintShare
